import { Link } from 'react-router-dom';
import { ArrowLeftIcon, BookOpenIcon } from '@heroicons/react/24/outline';
import AdminHeader from '../../../shared/components/AdminHeader';
import { getGradeLevelLabel } from '../../../shared/constant/gradeLevels';
import { useOwnSubjects } from '../hooks/useOwnSubjects';

function GradesPage() {
  const { subjects, loading, error } = useOwnSubjects();

  return (
    <div className="min-h-dvh w-full flex flex-col bg-appbg">
      <AdminHeader />

      <main className="flex-1 w-full p-4 lg:w-4/5 lg:mx-auto space-y-4">
        <div className="flex items-center gap-2">
          <Link to="/dashboard" aria-label="Back to dashboard" className="text-[#0b4a71] hover:text-[#3f6d8e]">
            <ArrowLeftIcon className="h-6 w-6" />
          </Link>
          <h1 className="text-2xl font-semibold text-[#0b4a71]">Grades Per Subject</h1>
        </div>

        {loading ? (
          <p className="w-full text-center text-gray-500 py-12">Loading…</p>
        ) : error ? (
          <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">{error}</p>
        ) : subjects.length === 0 ? (
          <div className="bg-white rounded-lg border border-gray-200 p-8 text-center text-gray-500">
            No subjects assigned to you yet.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {subjects.map((subject) => (
              <Link
                key={subject.id}
                to={`/dashboard/grades/${subject.id}`}
                className="bg-white rounded-lg border border-gray-200 p-5 space-y-3 hover:border-[#4ea6d0] hover:shadow-md transition"
              >
                <div className="h-10 w-10 rounded-md bg-[#0b4a71]/10 flex items-center justify-center">
                  <BookOpenIcon className="h-6 w-6 text-[#0b4a71]" />
                </div>
                <div>
                  <p className="font-semibold text-[#0b4a71]">{subject.name}</p>
                  <p className="text-sm text-gray-500">
                    {[subject.grade_level && getGradeLevelLabel(subject.grade_level), subject.category]
                      .filter(Boolean)
                      .join(' - ')}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

export default GradesPage;
